import { useState, useEffect } from 'preact/hooks';
import { timeInSeconds } from '@/utils';

const getRemaining = (time, timerStarted = 0, valid) => {
	if (valid) {
		return 0;
	}
	if (!timerStarted) {
		return time;
	}
	const diff = timeInSeconds() - timerStarted;
	const remaining = time - diff;
	return remaining > 0 ? remaining : 0;
};

export default function useRemainingTime({ time, timerStarted, valid, start }) {
	const [remaining, setRemaining] = useState(getRemaining(time, timerStarted, valid));
	useEffect(() => {
		if (!timerStarted || remaining <= 0 || !time) return;

		const interval = setInterval(() => {
			if (remaining === 0) {
				clearInterval(interval);
			}
			setRemaining(getRemaining(time, timerStarted));
		}, 1000);

		return () => clearInterval(interval);
	}, [remaining, time, timerStarted]);

	return {
		remaining,
		finished: remaining <= 0 || !time,
	};
}
